import { Component, OnInit } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, FormBuilder, Validators } from '@angular/forms'; 
import { UserService, OperationsService, AuthenticationService, StorageService } from '../../_services/index';
import {ToastrService} from 'ngx-toastr';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-plgrouping',
  templateUrl: './plgrouping.component.html',
  styleUrls: ['./plgrouping.component.css']
})
export class PlgroupingComponent implements OnInit {
  newAccountForm: FormGroup;
  choosefromdefault = '1';
  public GROUP_TITLE:''
  public GROUP_CATEGORY:''
  GROUP_CATEGORY_ID = '0';
  public currentUser: any;
  public loading = false;
  public filter = { PLDDATE: '', PLDDATE_: '', SHOW_ZERO_BALANCE: false }
  public data: any;
  open_group: boolean = false;
  accounts: any;
  account_id: any;
  accounts_ids: any = [];
  accounts_idss: any = [];
  add_item: boolean = false;
  group_id: any;
  no_data = false;
  default_balance_sheet_groups:any;
  public group = { GROUP_TITLE: '', GROUP_CATEGORY: '', LENDER_ACCOUNT_ID: [] }
  constructor(public fb: FormBuilder, public operationsService: OperationsService, public storageService: StorageService, private toastr: ToastrService) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.newAccountForm = new FormGroup({
      GROUP_TITLE: new FormControl(),
      GROUP_CATEGORY: new FormControl(),
      LENDER_ACCOUNT_ID: new FormControl()
    })
  }


  ngOnInit() {
    // this.getPLGrouping();
    this.getAccounts();
    this.listPlGroup();
  }
  
  getPLGrouping() {
    this.operationsService.getPLGrouping(this.currentUser.token)
      .subscribe(data => {
        this.data = data
      });
  }
  getPLGroupsByCategory(event){
    this.operationsService.getPLGroupsByCategory(this.currentUser.token, this.GROUP_CATEGORY_ID).subscribe(res => {
      this.default_balance_sheet_groups = res.balance_sheet_groups; 
    });
  }
  showSuccess(msg) {
    return this.toastr.success(msg, 'Success');
  }
  showError(msg) {
    return this.toastr.error(msg, 'Error');
  }
  getAccounts() {
    this.operationsService.displayAccounts(this.currentUser.token).subscribe(res => {
      this.accounts = res.all_accounts;
    });
  }
  addAccount() {
     console.log(this.newAccountForm.controls['LENDER_ACCOUNT_ID'].value.id)
     this.accounts_ids.push(this.newAccountForm.controls['LENDER_ACCOUNT_ID'].value.id);
     this.accounts_idss.push(this.newAccountForm.controls['LENDER_ACCOUNT_ID'].value.account_name)
  }
  setAccSelected(event){
    console.log(event.target.value)
  }
  addPlGroup() {
    this.GROUP_TITLE = this.newAccountForm.controls['GROUP_TITLE'].value
    if (!this.GROUP_TITLE) {
      return this.showError('Group title is required');
    }
    this.GROUP_CATEGORY = this.newAccountForm.controls['GROUP_CATEGORY'].value
    if (!this.GROUP_CATEGORY) {
      return this.showError('Select a category');
    }
    if (!this.accounts_ids) {
      return this.showError('Select an account');
    }
    this.loading = true;
    this.operationsService.addPlGroup(this.currentUser.token, this.GROUP_TITLE, this.GROUP_CATEGORY, this.accounts_ids).subscribe(res => {
      console.log(res);
      if (res.status) {
        this.loading = false;
        this.showSuccess(res.response);
        this.listPlGroup();
        this.GROUP_CATEGORY = '';
        this.GROUP_TITLE = '';
        this.accounts_ids = [];
      } else {
        this.showError(res.response);
        this.loading = false;
      }
    }, err => {
      this.showError('An error occured, try again');
      this.loading = false;
    });
  }
  listPlGroup() {
    this.operationsService.listPlGroup(this.currentUser.token).subscribe(res => {
      if (res.status) {
        this.no_data = false;
        this.data = res.pl_groups;
      } else {
        this.no_data = true;
      }
    });
  }
  openGroup() {
    this.open_group = !this.open_group;
    this.add_item = false;
  }
  getCategoryName(category_id) {
    if (category_id == 1) {
      return 'Income';
    }
    if (category_id == 2) {
      return 'Expenses';
    }
    if (category_id == 3) {
      return 'Income tax';
    }
    if (category_id == 4) {
      return 'OCI';
    }
  }
  deleteGroup(group_id) {
    this.loading = true;
    this.operationsService.deletePlGroup(this.currentUser.token, group_id).subscribe(res => {
      if (res.status) {
        this.loading = false;
        this.showSuccess(res.response);
        this.listPlGroup();
      } else {
        this.loading = false;
        this.showError(res.response);
      }
    }, err=> {
      this.loading = false;
    });
  }
  addItem(group_id, group_title, group_category_id) {
    this.add_item = !this.add_item;
    this.group_id = group_id;
    this.GROUP_TITLE = group_title;
    this.open_group = false;
    this.accounts_ids = []
    this.accounts_idss = []
    this.GROUP_CATEGORY = group_category_id

    console.log(this.GROUP_CATEGORY)
  }
  updatePlGroup() {
    // if (!this.GROUP_TITLE) {
    //   return this.showError('Group title is required');
    // }
    if (!this.group_id) {
      return this.showError('Select a category');
    }
    if (!this.accounts_ids) {
      return this.showError('Select an account');
    }
    this.loading = true;
    this.operationsService.updatePlGroup(this.currentUser.token, this.GROUP_TITLE, this.GROUP_CATEGORY, this.accounts_ids, this.group_id).subscribe(res => {
      if (res.status) {
        this.loading = false;
        this.showSuccess(res.response);
        this.GROUP_TITLE = "";
        this.GROUP_CATEGORY = "";
        this.accounts_ids = [];
        this.listPlGroup();
      } else {
        this.showError(res.response);
        this.loading = false;
      }
    }, err => {
      this.loading = false;
    })
  }
  moveGroupUp(group_id, up, group_category_id) {
    this.operationsService.moveGroupOrder(this.currentUser.token, group_id, up, false, group_category_id).subscribe(res => {
      if (res.status) {
        this.listPlGroup();
        this.showSuccess(res.response);
      } else {
        this.showError(res.response)
      }
    }, err => {
      this.showError('An error occurred, try again');
    });
  }
  moveGroupDown(group_id, down, group_category_id) {
    this.operationsService.moveGroupOrder(this.currentUser.token, group_id, false, down, group_category_id).subscribe(res => {
      if (res.status) {
        this.listPlGroup();
        this.showSuccess(res.response);
      }
    }, () => {
      this.showError('An error occurred, try again');
    });
  }
  deleteGroupItem(group_item_id, account_id) {
    this.operationsService.deleteAccountFromGroup(this.currentUser.token, group_item_id, account_id).subscribe(res => {
      if (res.status) {
        this.showSuccess(res.response);
        this.listPlGroup();
      } else {
        this.showError(res.response)
      }
    }, () => {
      this.showError('An error occurred, try again');
    });
  }
  moveAccountRight(group_id, right, group_item_id) {
    return this.operationsService.moveAccountOrder(this.currentUser.token, group_id, false, right, group_item_id).subscribe(res => {
      if (res.status) {
        this.listPlGroup();
        this.showSuccess(res.response);
      } else {
        this.showError(res.response);
      }
    }, () => this.showError('An error occurred, try again'));
  }
  moveAccountLeft(group_id, left, group_item_id) {
    return this.operationsService.moveAccountOrder(this.currentUser.token, group_id, left, false, group_item_id).subscribe(res => {
      if (res.status) {
        this.listPlGroup();
        this.showSuccess(res.response);
      } else {
        this.showError(res.response);
      }
    }, () => this.showError('An error occurred, try again'));
  }
  removeAcc(index){
    this.accounts_ids.splice(index)
    this.accounts_idss.splice(index)
  }
}
